(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pack-picker"] && !Shopify.designMode) return;
  try {
    class PackPicker extends HTMLElement {
    connectedCallback() {
      const data = this.querySelector('script[type="application/json"]');
      this.urlsByProduct = data ? JSON.parse(data.textContent) : {};
      this.handleVariantUpdate = (event) => {
        const variant = event.detail ? event.detail.resource : null;
        if (!variant || !variant.option1) return;
        this.querySelectorAll('a[data-product-handle]').forEach((link) => {
          const urls = this.urlsByProduct[link.dataset.productHandle];
          if (urls && urls[variant.option1]) link.setAttribute('href', urls[variant.option1]);
        });
      };
      document.addEventListener('variant:update', this.handleVariantUpdate);
    }

    disconnectedCallback() {
      document.removeEventListener('variant:update', this.handleVariantUpdate);
    }
  }

  if (!customElements.get('pack-picker')) {
    customElements.define('pack-picker', PackPicker);
  }
  } catch(e) { console.error(e); }
})();

})();
